import React from "react";

import {
  makeStyles,
  useTheme,
  Grid,
  Paper,
  useMediaQuery,
  Button,
  ListItemText,
  List,
  ListItem,
  Typography,
  AppBar,
  CssBaseline
} from "@material-ui/core";
import agcLogo from "./images/SIP_template.png";
import sipAbacusLogo from "./images/sip-academy-logo1.png";
import plusLeft from "./images/plusSignLeft.svg";
import plusRight from "./images/plusSignRight.svg";
import agcDoll from "./images/DOLL_P3.svg";
import backgroudImage from "./images/BG_Page_03.svg";
import mobileBG from "./images/mobileBG.svg";
//import backgroudImage2022 from "./images/BG_Page_2022.png";
import mobileBG2022 from "./images/Arithmetic_Genius_Contest_Mobile_BG.jpg";
import backgroudImage2022 from "./images/BG_2022_AGC.jpg";
import agc2023mobileLogo from "./images/Bg_2023_mobile.png";
import agc2023WebLogo from "./images/Bg_2023_web.png";
import agc2024mobileLogo from "./images/Bg_2024_mobile.png";
import agc2024WebLogo from "./images/Bg_2024_web.png";
import agc2025WebLogo from "./images/Plain_Background.png";
import agc2025logo from "./images/AGC Logo 2025.png";
import title2025 from "./images/Title_Template.png";

const useStyles = makeStyles(theme => ({
  aboutAGCRoot: {
    backgroundColor: "white",
    alignContent: "stretch",
    flexWrap: "nowrap"
  },
  prizePaper: {
    width: "160%",
    height: "145vh",
    backgroundImage: `url(${agc2025WebLogo})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover"
  },

  prizeMobilePaper: {
    width: "100%",
    height: "'150vh'",
    backgroundImage: `url(${agc2025WebLogo})`,
    backgroundColor: "white",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover"
  },
  registrationPageLink: {
    textDecoration: "none"
  },

  button: {
    color: "white",
    backgroundColor: "#E62127",
    fontWeight: "bold",
    borderRadius: theme.spacing(1),
    display: "inline-block",
    textAlign: "center"
  },
  prizeTitle: {
    textAlign: "center",
    color: "white",
    backgroundColor: "#E62127",
    fontWeight: "bold",
    borderRadius: "10px",
    height: "85%",
    whiteSpace: "pre-line",
    display: "inline-block",
    fontSize: theme.spacing(2),
    padding: theme.spacing(3)
  },
  text: {
    fontSize: "16px",
    fontWeight: "bold",
    color: "#000000"
  },
  prizeContent: {
    textAlign: "left",
    fontSize: theme.spacing(3),
    // color: "#404040",
    whiteSpace: "pre-line"
  },
  prizeBox: {
    border: "4px solid #E62127",
    borderRadius: "4px",
    padding: "3px 5px",
    textAlign: "center",
    shadowColor: "#F5E740",
    shadowOffset: {
      width: 0,
      height: 12
    },
    shadowOpacity: 0.58,
    shadowRadius: 16.0,
    whiteSpace: "pre-line",
    fontSize: "16px",
    fontWeight: "bold",
    color: "#000000"
  }
}));

const AGCWorkFlow = () => {
  const theme = useTheme();
  const classes = useStyles();
  const smallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const title = "Summary of Prizes";
  const round1 = " Round 1 – School Level";
  const round2 = " Round 4 – National Finals";
  const round3 = "  Round 2 – School Level ";
  const round4 = " Round 3 – State Finals";
  const register = "SAMPLE QUESTION PAPER";

  function ContentToBeDisplayed() {
    if (smallScreen) {
      return (
        <React.Fragment>
          <Grid container style={{ marginTop: "20px", padding: "0 10%" }}>
            <Grid item xs={12}>
              <div className={classes.prizeBox}>{round1}</div>
              <List className={classes.prizeContent}>
                <ListItem>
                  <ListItemText className={classes.prizeContent}style ={{ marginBottom: '-15px' }}>
                    <Typography className={classes.text}>
                      {" "}
                      🏅 Certificates for all participants & winners
                    </Typography>
                  </ListItemText>
                </ListItem>
              </List>
            </Grid>
          </Grid>
          <Grid container style={{ marginTop: "20px", padding: "0 10%" }}>
            <Grid item xs={12}>
              <div className={classes.prizeBox}>{round3}</div>
              <List className={classes.prizeContent}>
                <ListItem>
                  <ListItemText className={classes.prizeContent}style ={{ marginBottom: '-15px' }}>
                    <Typography className={classes.text}>
                      🥇 Medals + Certificates for Winners
                    </Typography>
                  </ListItemText>
                </ListItem>
              </List>
            </Grid>
          </Grid>
          <Grid container style={{ marginTop: "20px", padding: "0 10%" }}>
            <Grid item xs={12}>
              <div className={classes.prizeBox}>{round4}</div>
              <List className={classes.prizeContent}>
                <ListItem>
                  <ListItemText className={classes.prizeContent}style ={{ marginBottom: '-15px' }}>
                    <Typography className={classes.text}>
                      🏆 1st Prize: ₹10,000 | 2nd: ₹7,000 | 3rd: ₹5,000
                    </Typography>
                  </ListItemText>
                </ListItem>
                <ListItem>
                  <ListItemText className={classes.prizeContent}style ={{ marginBottom: '-15px' }}>
                    <Typography className={classes.text}>
                      🏫 Champion School: ₹15,000 + Trophy
                    </Typography>
                  </ListItemText>
                </ListItem>
              </List>
            </Grid>
          </Grid>
          <Grid container style={{ marginTop: "20px", padding: "0 10%" }}>
            <Grid item xs={12}>
              <div className={classes.prizeBox}>{round2}</div>
              <List className={classes.prizeContent}>
                <ListItem>
                  <ListItemText className={classes.prizeContent}style ={{ marginBottom: '-15px' }}>
                    <Typography className={classes.text}>
                      🏆 1st Prize: ₹25,000 | 2nd: ₹15,000 | 3rd: ₹10,000.
                    </Typography>
                  </ListItemText>
                </ListItem>
              </List>
            </Grid>
          </Grid>
          <Grid
            container
            sm={12}
            xs={12}
            justifyContent="flex-end"
            alignItems="flex-end"
          ></Grid>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <Grid container direction="row">
            <Grid item md={3} lg={3} xl={3}>
              {/* <img src={agcDoll} alt="doll"  style={{ marginTop:theme.spacing(22)}}/> */}
            </Grid>

            <Grid item md={6} lg={6} xl={6}>
              <Grid item container spacing={4}>
                <Grid
                  item
                  md={4}
                  lg={4}
                  xs={10}
                  xl={4}
                  className={classes.prizeContent}
                  style={{ textAlign: "left" }}
                >
                  <div className={classes.prizeBox}>{round1}</div>
                  <List className={classes.prizeContent}>
                    <ListItem>
                      <ListItemText className={classes.prizeContent}>
                        <Typography className={classes.text}>
                          🏅 Certificates for all participants & winners
                        </Typography>
                      </ListItemText>
                    </ListItem>
                  </List>
                  <div className={classes.prizeBox}>{round2}</div>
                  <List className={classes.prizeContent}>
                    <ListItem>
                      <ListItemText className={classes.prizeContent}>
                        <Typography className={classes.text}>
                          🏆 1st Prize: ₹25,000 | 2nd: ₹15,000 | 3rd: ₹10,000.
                        </Typography>
                      </ListItemText>
                    </ListItem>
                  </List>
                  <br></br>
                </Grid>

                <Grid
                  item
                  md={4}
                  lg={4}
                  xs={10}
                  xl={4}
                  className={classes.prizeContent}
                  style={{ textAlign: "left" }}
                >
                  <div className={classes.prizeBox}>{round3}</div>
                  <List className={classes.prizeContent}>
                    <ListItem>
                      <ListItemText className={classes.prizeContent}>
                        <Typography className={classes.text}>
                          🥇 Medals + Certificates for Winners
                        </Typography>
                      </ListItemText>
                    </ListItem>
                  </List>
                </Grid>

                <Grid
                  item
                  md={4}
                  lg={4}
                  xs={10}
                  xl={4}
                  className={classes.prizeContent}
                  style={{ textAlign: "left" }}
                >
                  <div className={classes.prizeBox}>{round4}</div>
                  <List className={classes.prizeContent}>
                    <ListItem>
                      <ListItemText className={classes.prizeContent}>
                        <Typography className={classes.text}>
                          🏆 1st Prize: ₹10,000 | 2nd: ₹7,000 | 3rd: ₹5,000
                        </Typography>
                      </ListItemText>
                    </ListItem>
                    <ListItem>
                      <ListItemText className={classes.prizeContent}>
                        <Typography className={classes.text}>
                          🏫 Champion School: ₹15,000 + Trophy
                        </Typography>
                      </ListItemText>
                    </ListItem>
                  </List>
                </Grid>
              </Grid>
            </Grid>

            <Grid item md={3} lg={3} xl={3}></Grid>
          </Grid>
        </React.Fragment>
      );
    }
  }

  return (
    <React.Fragment>
      <CssBaseline />
      <Grid container justifyContent="center" alignItems="center">
        <Paper
          className={
            smallScreen ? classes.prizeMobilePaper : classes.prizePaper
          }
        >
          <Grid item container md={12} xs={12} lg={12} sm={12} xl={12}>
            <AppBar position="static" style={{ backgroundColor: "#E62127" }}>
              <Grid item md={3} xs={3} lg={3} sm={3} xl={3}></Grid>
              <Grid item md={4} xs={9} sm={9} lg={4} xl={4}>
                <img
                  src={sipAbacusLogo}
                  alt="logo"
                  height={smallScreen ? "60%" : "60%"}
                  width={smallScreen ? "60%" : "50%"}
                />
              </Grid>
              <Grid item md={5} xs={0} sm={0} lg={5} xl={5}></Grid>
            </AppBar>
          </Grid>

          <Grid item container>
            <Grid item xs={12}>
              <div
                style={{
                  position: "relative",
                  width: "100vw",
                  height: "200px"
                }}
              >
                <img
                  src={agc2025logo}
                  style={{
                    position: "absolute",
                    top: smallScreen ? "30px" : "80px",
                    left: smallScreen ? "40px" : "150px",
                    width: smallScreen ? "80px" : "200px",
                    height: smallScreen ? "80px" : "200px",
                    zIndex: 2
                  }}
                />
                <img
                  src={agcLogo}
                  alt="Logo"
                  style={{
                    width: "100%",
                    height: smallScreen ? "80px" : "200px",
                    display: "block"
                  }}
                />
              </div>
            </Grid>
            <Grid item md={3} xs={6} sm={6} lg={3} xl={3}>
              <Grid item container style={{ marginTop: theme.spacing(3) }}>
                <Grid
                  item
                  md={3}
                  xs={2}
                  sm={2}
                  lg={3}
                  xl={3}
                  alignContent="flex-end"
                ></Grid>

                <Grid item md={6} xs={8} sm={8} lg={6} xl={6}>
                  <a
                    href="#sampleQuestionPaper"
                    className={classes.registrationPageLink}
                  >
                    <Button
                      style={{
                        top: smallScreen ? "-160px" : "650px",
                        width: "100%",
                        left: smallScreen ? "210px" : "580px",
                        fontSize: smallScreen ? "10px" : "14px"
                      }}
                      variant="contained"
                      className={classes.button}
                    >
                      {register}
                    </Button>
                  </a>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            container
            md={12}
            xs={12}
            lg={12}
            sm={12}
            xl={12}
            style={{
              marginTop: smallScreen ? -theme.spacing(15) : theme.spacing(8),
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "relative"
            }}
          >
            <img
              src={title2025}
              style={{
                width: smallScreen ? "90vw" : "600px",
                height: smallScreen ? "70px" : "100px",
                position: "absolute",
                top: smallScreen ? "-20px" : "-110px"
              }}
            />
            <Typography
              style={{
                position: "absolute",
                color: "white",
                fontWeight: "bold",
                fontSize: smallScreen ? "16px" : "25px",
                textAlign: "center",
                width: "80%",
                top: smallScreen ? "10px" : "-60px",
                transform: "translateY(-50%)"
              }}
            >
              {title}
            </Typography>
          </Grid>

          <br />
          <br />

          <ContentToBeDisplayed></ContentToBeDisplayed>

          <Grid
            container
            justifyContent="flex-end"
            alignItems="center"
            direction="column"
          >
            <Typography className={classes.text}>

               <div style={{
                   border: '4px solid gold',
                  padding: smallScreen ? '10px' : '12px',
                  borderRadius: '8px',
                  color: '#000',
                  maxWidth: smallScreen ? "700px" : '1000px',      
                  textAlign: 'center',
                  fontSize: smallScreen ? "15px" : "20px",
                  marginTop: smallScreen ? '15px' : '0',       
                  }}>
                🚀 Bonus: National Winners get an exclusive chance to witness a
                Live ISRO Rocket Launch from Sriharikota!
              </div>
              <br></br>
            </Typography>
            <Typography
                          variant={smallScreen ? "h10" : "h6"}
                          style={{ color: "black",
                                   fontWeight: "bold",
                                   marginTop: smallScreen ? '10px' : '0',
                                   marginBottom: smallScreen ?'20px' :'0'
                           }}
                        >
           *Not applicable in Odisha and Tripura. A few other smaller states are combined as a Region.
             </Typography>

          </Grid>
        </Paper>
      </Grid>
    </React.Fragment>
  );
};

export default AGCWorkFlow;
